import React from 'react'
import Portal from '../Portal/Portal'
import Overlay from '../Overlay/Overlay'
import CleverAlphaButton from '../CleverAlphaButton/CleverAlphaButton'
import ConfirmationModal from './confirmation_modal'
import DoubleSlider from '../DoubleSlider/DoubleSlider'
import InputField from '../InputField/InputField'
// import AdjustRiskHistory from './adjust_risk_history'
import { setUserRisk } from '../../dashboard/user/actions'
import { useDispatch } from 'react-redux'
import { updateRisk } from './reducer'

const AdjustRiskModal = ({ token, username, accountIndex, risk, handleClose, wlfId, itemIndex }) => {
    const riskTrimmed = risk.toFixed(2);
    const min = 0;
    const max = 1;

    const [riskValue, setRiskValue] = React.useState(riskTrimmed);
    const [riskLabelValue, setRiskLabelValue] = React.useState(riskTrimmed);
    const dispatch = useDispatch();

    const handleSliderChange = (value) => {
        setRiskLabelValue(value);
        setRiskValue(value);    
    }

    const handleChange = (e) => {
        const value = e.target.value;
        const isTwoDecimalPlaces = /^$|^(\.?(\d{1,2}(\.\d{0,2})?|0(\.\d{0,2})?|1(\.0{0,2})?)?)$/;
        if(!isTwoDecimalPlaces.test(value)) {
            return;
        }

        if(value < 0 || value > 1) {
            return;
        }
        const labelValue = value ? value : 0;
        setRiskLabelValue(value);
        setRiskValue(labelValue);
    }

    const handleSubmit = async () => {
        try {
            const response = await setUserRisk(token, username, accountIndex, riskValue);
            if(response.status !== "OK") {
                throw new Error("Something went wrong");
            }

            dispatch(updateRisk(riskValue, wlfId, itemIndex));
        } catch (error) {
            console.log(error);
        }

        return handleClose;
    }

    const title = 'Risk Level';
    const content = 'Increasing the risk level of your portfolio will increase your exposure to volatility which may increase the long run expected return of your portfolio; however, it also may increase the possibility for draw downs of your portfolio value.';

    return (
        <Portal>
            <Overlay>
                <div style={{ display: "flex", justifyContent: "center", gap: "8px", width: "70%"}}>
                    <div style={{ display: "flex", flexDirection: "column", position: "relative", backgroundColor: "white", padding: "24px 48px", border: "1px solid black", width: "60%" }}>
                        <div style={{ fontWeight: "bold", fontSize: "16px" }} >Portfolio Adjustment - Risk</div>
                        
                        <div style={{ marginBottom: "24px" }}>
                            <DoubleSlider min={min} max={max} step={0.01} value={riskValue} currentValue={risk} labelEndText={'Risk'} horizontalLabel={'Risk'} onChange={handleSliderChange}/>
                        </div>

                        <div style={{ marginBottom: "24px" }}>
                            <InputField name="risk" label="Risk" value={riskLabelValue} onChange={handleChange}/>
                        </div>

                        <div style={{ display: "flex", justifyContent: "center", gap: "8px", marginTop: 'auto' }}>
                            <CleverAlphaButton onClick={handleClose}>Cancel</CleverAlphaButton>
                            <ConfirmationModal title={title} content={content} handleSubmit={handleSubmit}>Ok</ConfirmationModal>
                        </div>
                    </div>
                    {/* <div style={{ display: "flex", flexDirection: "column", position: "relative", backgroundColor: "white", padding: "24px", border: "1px solid black"}}>
                        <div style={{ fontWeight: "bold", fontSize: "16px" }}>Portfolio Adjustment Risk History</div>
                        <AdjustRiskHistory />
                    </div> */}
                </div>
            </Overlay>
        </Portal>
    )
}

export default AdjustRiskModal